var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "siteBox" },
    [
      _vm._m(0),
      _vm._m(1),
      _c(
        "div",
        { staticClass: "siteContent fx" },
        [
          _c(
            "div",
            { staticClass: "itemList fx" },
            [
              _c("span", [_vm._v("站点名称：")]),
              _c("el-input", {
                staticStyle: { width: "290px" },
                attrs: {
                  maxlength: "80",
                  placeholder: "请输入网站或网页的名称",
                },
                model: {
                  value: _vm.listQuery.siteName,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "siteName", $$v)
                  },
                  expression: "listQuery.siteName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "itemList fx" },
            [
              _c("span", [_vm._v("网址地址：")]),
              _c("el-input", {
                staticStyle: { width: "290px" },
                attrs: { placeholder: "请输入含http://或https://的网址" },
                model: {
                  value: _vm.listQuery.mainUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "mainUrl", $$v)
                  },
                  expression: "listQuery.mainUrl",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { height: "36px" },
              attrs: { type: "dialog-confirm", w80: "" },
              on: { click: _vm.saveOrUpdateSite },
            },
            [_vm._v("确认添加")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "siteBottom" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  type: "index",
                  label: "序列",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "inputUrl",
                  label: "站点/URL",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "siteName", label: "站点名称" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "createDate",
                  label: "创建时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "status",
                  label: "安装状态(监测到流量)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              "status-a",
                              scope.row.status == 1 ? "success" : "error",
                            ],
                            staticStyle: { "margin-left": "-10px" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.status == 1 ? "已成功" : "未成功"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "追踪代码存档" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              color: "#5088FF",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.clickCode(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s("查看代码"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "name", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.clickEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("修改站点名称")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.clickDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination greyblock" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.listQuery.pageSize,
                  pageNum: _vm.listQuery.pageNum,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改站点名称",
            "custom-class": "dialog-s",
            visible: _vm.dialogFormVisible,
            width: "350px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "fx" },
            [
              _c("span", { staticClass: "checkname" }, [_vm._v("站点名称")]),
              _c("el-input", {
                attrs: { size: "small", maxlength: "80" },
                model: {
                  value: _vm.EditsiteName,
                  callback: function ($$v) {
                    _vm.EditsiteName = $$v
                  },
                  expression: "EditsiteName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", w88: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", w88: "" },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "代码存档",
            visible: _vm.dialogCode,
            width: "690px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCode = $event
            },
          },
        },
        [
          _c(
            "p",
            { staticClass: "info", staticStyle: { "margin-top": "12px" } },
            [
              _vm._v(
                "将这段追踪代码贴到您的网页/页面上,即可识别访客背后的企业,让您与客户更进一步！"
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingJs,
                  expression: "loadingJs",
                },
              ],
              staticClass: "codeContent",
              staticStyle: { "margin-top": "16px", color: "#555555" },
              attrs: { id: "copyText" },
            },
            [_vm._v(" " + _vm._s(_vm.content) + " ")]
          ),
          _c(
            "div",
            { staticStyle: { "padding-bottom": "14px" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "no-bg",
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.clickCopy },
                },
                [_vm._v("复制")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            "custom-class": "dialog-s",
            visible: _vm.isDel,
            width: "350px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isDel = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                "padding-top": "16px",
                "padding-bottom": "24px",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-warning-outline",
                staticStyle: { "font-size": "50px", color: "#E6A23C" },
              }),
              _c(
                "p",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "font-weight": "400",
                    color: "#333333",
                    "line-height": "20px",
                    "margin-top": "10px",
                  },
                },
                [_vm._v("确定删除此站点吗？")]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", w88: "" },
                  on: {
                    click: function ($event) {
                      _vm.isDel = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", w88: "" },
                  on: { click: _vm.openOkk },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("setDrawer", { ref: "setDrawer" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "siteHead" }, [
      _c("i", {
        staticClass: "el-icon-warning",
        staticStyle: {
          color: "rgba(48, 191, 120, 1)",
          "font-size": "16px",
          "margin-right": "10px",
        },
      }),
      _c("span", [_vm._v("温馨提示：")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sub-head", staticStyle: { "font-size": "13px" } },
      [
        _c("p", [
          _vm._v(
            "添加的站点请跟添加追踪代码的站点保持一致，否则系统将无法识别站点对应的访客"
          ),
        ]),
        _c("p", [_vm._v("安装代码成功后则不能再修改站点url地址")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }